// extracted by mini-css-extract-plugin
export default {"root":"RangeValue-module__root___Px_1n","value":"RangeValue-module__value___bA7UK","unit":"RangeValue-module__unit___mZIcw"};